import PropTypes from "prop-types";

const ReactMenuItemType = PropTypes.shape({
  component: PropTypes.string.isRequired,
  group: PropTypes.string,
  props: PropTypes.object,
  react: PropTypes.bool.isRequired,
});

export default ReactMenuItemType;
